import { render } from "./activityCreate.vue?vue&type=template&id=6ed83ace&scoped=true"
import script from "./activityCreate.vue?vue&type=script&lang=js"
export * from "./activityCreate.vue?vue&type=script&lang=js"

import "./activityCreate.vue?vue&type=style&index=0&id=6ed83ace&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed83ace"]])

export default __exports__